import { useEffect } from 'react';
import { ProductEventDataList } from 'corgi-types';

import { ProductEvent } from 'common/enums/Tracking';
import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { getProductViewEventData } from 'common/tracking/productEventData';
import type { TrackedAccessory } from 'common/types/accessory-slider';

interface ViewsTrackerOptions {
  viewedItems: number[];
  sellableItems: TrackedAccessory[];
  slidesToShow?: number;
}

interface GetViewImpressionsOptions {
  sellableItems: TrackedAccessory[];
  currentSlideIndex: number;
  slidesToShow: number;
}

const dispatchProductViewEvent = (products: Array<ReturnType<typeof getProductViewEventData>>) =>
  dispatchTrackingEventGA4({
    event: ProductEvent.View,
    item_list_name: ProductEventDataList.Accessories,
    items: products,
  });

const getViewImpressions = ({
  sellableItems,
  currentSlideIndex,
  slidesToShow,
}: GetViewImpressionsOptions) =>
  sellableItems
    .slice(currentSlideIndex, currentSlideIndex + slidesToShow)
    .map(({ tracking }, index) =>
      getProductViewEventData({
        position: index + currentSlideIndex,
        tracking,
        list: ProductEventDataList.Accessories,
      })
    );

export const useViewsTracker = ({
  viewedItems,
  sellableItems,
  slidesToShow,
}: ViewsTrackerOptions) => {
  const currentSlideIndex = viewedItems[viewedItems.length - 1];

  useEffect(() => {
    if (slidesToShow) {
      const productViewImpressions = getViewImpressions({
        sellableItems,
        slidesToShow,
        currentSlideIndex,
      });
      if (productViewImpressions.length) {
        dispatchProductViewEvent(productViewImpressions);
      }
    }
  }, [slidesToShow, sellableItems, currentSlideIndex]);
};
